function getUrlParams(href) {
    if (!href || href === "#") {
        return null;
    }
    const url = new URL(href);
    const rawParams = url.search.substring(1).replace(/\?/g, '&');
    const urlParams = new URLSearchParams(rawParams);
    let idProject = urlParams.get('idProject') || '';
    let fieldIngresos = urlParams.get('fieldIngresos') || '';
    let product = urlParams.get('product') || '';
    if (!idProject && urlParams.get('dest')) {
        let dest = decodeURIComponent(urlParams.get('dest') || '');
        const fixedDest = dest.replace(/\?/g, (match, index) => {
            return index === dest.indexOf('?') ? '?' : '&';
        });
        const destUrl = new URL(fixedDest);
        const destParams = new URLSearchParams(destUrl.search);
        idProject = destParams.get('idProject') || '';
        fieldIngresos = destParams.get('fieldIngresos') || '';
        product = destParams.get('product') || '';
    }
    return { idProject, product, fieldIngresos };
}
function setBannerAttributes(banner, href, target) {
    const { idProject, fieldIngresos, product } = getUrlParams(href) || {};
    const bannerLink = banner.querySelector('a');
    const isBlog = window.location.pathname.includes('blog');
    const bannerId = banner.getAttribute('id');
    if (bannerLink && idProject && parseInt(idProject)) {
        bannerLink.setAttribute('href', '#');
        bannerLink.setAttribute('data-bs-toggle', 'modal');
        bannerLink.setAttribute('data-bs-target', target);
        bannerLink.setAttribute('onclick', `projectForm('${isBlog ? 'ads-blog' : bannerId}', ${idProject})`);
        bannerLink.setAttribute('dataproject_href', idProject || '');
        bannerLink.setAttribute('dataproject_text', fieldIngresos || '');
        bannerLink.setAttribute('dataproject_product', product || '');
        banner.style.cursor = 'pointer';
    }
}
let attempts = 0;
const maxAttempts = 3;
export function checkTopComponent() {
    let banners = document.querySelectorAll('.form-ads-result');
    if (window.location.pathname == '/') {
        banners = document.querySelectorAll('.content-ads-form');
    }
    banners.forEach((banner) => {
        const bannerId = banner.getAttribute('id');
        if (bannerId) {
            setTimeout(() => {
                const bannerLink = document.querySelector(`#${bannerId} a`);
                if (bannerLink && bannerLink.getAttribute('href')) {
                    const href = bannerLink.getAttribute('href');
                    setBannerAttributes(banner, href, '#modalPopup');
                }
            }, 600);
        }
        else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(checkTopComponent, 500);
        }
    });
}
export function setAttributesAdsBlog() {
    const banners = document.querySelectorAll('.ads-blog');
    banners.forEach((banner) => {
        banner.setAttribute('id', 'ads-blog');
        const bannerId = banner.getAttribute('id');
        if (bannerId) {
            setTimeout(() => {
                const bannerLink = document.querySelector(`#${bannerId} a`);
                if (bannerLink && bannerLink.getAttribute('href')) {
                    const href = bannerLink.getAttribute('href');
                    setBannerAttributes(banner, href, '#modalContacto');
                }
            }, 300);
        }
        else {
            setTimeout(setAttributesAdsBlog, 500);
        }
    });
}
export function setAttributesPopUp() {
    setTimeout(() => {
        const popUpLink = document.querySelector('.pop-up-ad a');
        if (popUpLink && popUpLink.getAttribute('href')) {
            const href = popUpLink.getAttribute('href');
            const { idProject, fieldIngresos, product } = getUrlParams(href) || {};
            if (idProject && parseInt(idProject)) {
                popUpLink.setAttribute('data-bs-toggle', 'modal');
                popUpLink.setAttribute('data-bs-target', '#modalPopup');
                popUpLink.setAttribute('onclick', `projectForm('pop-up', ${idProject})`);
                popUpLink.setAttribute('dataproject_href', idProject);
                popUpLink.setAttribute('dataproject_product', product || '');
                popUpLink.setAttribute('dataproject_text', fieldIngresos || '');
                popUpLink.setAttribute('dataproject_url', href);
                popUpLink.setAttribute('href', '#');
                const button = document.querySelector('#button-form-popup');
                if (button) {
                    button.setAttribute('onclick', `projectForm('pop-up', ${idProject})`);
                }
            }
            else {
                const iframe = document.querySelector('.pop-up-ad iframe');
                if (iframe) {
                    iframe.style.zIndex = '0';
                }
                const button = document.getElementById('button-form-popup');
                if (button) {
                    button.onclick = function () {
                        if (href) {
                            window.location.href = href;
                        }
                        else {
                            window.location.href = "/que-estas-buscando";
                        }
                    };
                }
            }
            const iframe = document.querySelector('.pop-up-ad iframe');
            if (iframe) {
                iframe.setAttribute('allow', 'autoplay');
                iframe.setAttribute('allowfullscreen', 'true');
            }
            const urlIframe = document.getElementById('url-iframe') ? document.getElementById('url-iframe').innerHTML.replace(/\s/g, '') : '';
            if (urlIframe) {
                const separator = urlIframe.includes('?') ? '&' : '?';
                iframe.src = `https://www.youtube.com/embed/${urlIframe}${separator}autoplay=1&mute=1&rel=0`;
            }
        }
    }, 300);
}
